import React, { useState } from "react";
import { Package, Search } from "lucide-react";
import EmptyState from "@/components/common/EmptyState";
import { useI18n } from "@/i18n/I18nProvider";

export default function TrackOrderPage() {
  const { t } = useI18n();
  const [order, setOrder] = useState("");
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <div className="text-center">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-secondary"><Package className="text-brand" /></span>
        <h1 className="mt-4 font-display text-3xl font-bold text-ink">{t("track_title")}</h1>
        <p className="mt-2 text-muted-foreground">{t("track_sub")}</p>
      </div>

      <form onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }} className="mt-8 flex gap-2">
        <input value={order} onChange={(e) => setOrder(e.target.value)} placeholder={t("order_number")} className="h-12 flex-1 rounded-full border border-border px-5 text-sm outline-none focus:border-brand" data-testid="track-input" required />
        <button className="flex h-12 items-center gap-2 rounded-full bg-brand px-6 text-sm font-bold text-brand-foreground" data-testid="track-submit"><Search size={16} /> {t("track_btn")}</button>
      </form>

      {submitted && (
        <div className="mt-8">
          <EmptyState icon={Package} title={`${t("order_number")}: ${order}`} body={t("no_tracking")} />
        </div>
      )}
    </div>
  );
}
